import classnames from 'classnames';
import React from 'react';
import { createUseStyles } from 'react-jss';

import { MapIcon } from '../../assets';

const useStyles = createUseStyles({
  icon: {
    color: '#FFFFFF',
    composes: ['is-absolute'],
    fontSize: 60,
    left: '50%',
    marginLeft: -30,
    marginTop: -68,
    top: '50%',
  },
  label: {
    background: 'rgba(0, 0, 0, 0.5)',
    borderRadius: 12,
    composes: [
      'is-italic',
      'is-bold',
      'fs8',
      'p6',
      'is-absolute',
      'text-center',
      'is-uppercase',
    ],
    left: '50%',
    letterSpacing: 0.08,
    lineHeight: 1.2,
    marginLeft: -50,
    top: '50%',
    width: 100,
  },
  wrapper: {
    composes: ['is-relative', 'is-full-layout'],
  },
});

const LoaderLabelComponent = function LoaderLabelComponent() {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <MapIcon className={classnames(classes.icon, 'vibrate')} />
      <div className={classes.label}>
        <span>Chargement...</span>
      </div>
    </div>
  );
};

LoaderLabelComponent.displayName = 'LoaderLabelComponent';

export default LoaderLabelComponent;
